<div style="width: 88%">
  <input authenticate-user="Timecard.ContactName.Update"
         authenticate-command="disabled"
         [required]="required"
         [(ngModel)]="contactSearchTerm"
         appInputRestriction="restrictChars"
         name="contactSearch"
         [typeahead]="contactObservable$"
         [typeaheadAsync]="true"
         [typeaheadOptionsLimit]="20"
         [typeaheadItemTemplate]="customItemTemplate"
         [typeaheadMinLength]="3"
         placeholder="{{placeholder}}"
         class="form-control"
         [isAnimated]="true"
         [typeaheadWaitMs]="200"
         (blur)="onBlur()"
         style="width:92%!important"
         autocomplete="off"
         (typeaheadOnSelect)="onContactSelected($event)">
</div>
<ng-template #customItemTemplate let-model="item" let-index="index">
  <!--<h5>This is: {{model | json}} Index: {{ index }}</h5>-->

  <strong>
    {{model.fullName ? model.fullName :model.code }} 
  </strong>

  <font size="2px" *ngIf="model.flaggedByhr">
    <div class="fa-stack fa-1x">
      <i class="fa fa-circle fa-stack-2x" style="color: red;"></i>
      <i class="fa fa-warning fa-stack-1x" style="color: yellow;"></i>
    </div>
  </font>
  <br />
  <font size="2px">
    <small>
      <div><strong>Business Sub-segment:</strong> {{model.subBusinessSegment ? model.subBusinessSegment :'' }}      </div>
      <div><strong>City:</strong>  {{model.city ? model.city:'' }}, <strong>State:</strong> {{model.state ? model.state:'' }}</div>
    </small>
  </font>

</ng-template>
